/*
 * 需求管理接口
 * */
import services from "../config/axios";
import base from './base';
// 定义参数类型
type paramsType<T> = {
  [key: string]: T;
};

const requireManageAPI = {
  // 获取需求列表
  getRequireList<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresList`, params);
  },
  getRequireListAdvance<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresListAdvance`, params);
  },
  //获取一个需求
  getRequireOne<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresOne`, params);
  },
  //获取需求操作步骤
  getRequireSteps<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresSteps`, params);
  },
  //保存需求
  addRequires<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AddRequires`, params);
  },
  //更新需求
  updateRequires<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequires`, params);
  },
  //更新需求
  updateRequiresAdmin<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresAdmin`, params);
  },
  //删除需求
  deleteRequires<T>(params: FormData) {
    return services.post(`${base.lk}/Require/DeleteRequires`, params);
  },
  //提交需求
  submitRequires<T>(params: FormData) {
    return services.post(`${base.lk}/Require/SubmitRequires`, params);
  },
  // 获取需求审核列表
  getAuditList<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetAuditList`, params);
  },
  // 获取需求审核数量
  getAuditNum<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetAuditNum`, params);
  },
  // 插入审核记录
  addAuditRecord<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AddAuditRecord`, params);
  },
  // 获取审核记录列表
  getAuditRecordList<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetAuditRecordList`, params);
  },
  // 审核需求
  auditRequires<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AuditRequires`, params);
  },
  // 审核需求tableau
  auditRequiresTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AuditRequiresTableau`, params);
  },
  // 审核需求tableau
  auditRequiresTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AuditRequiresTeambition`, params);
  },
  // 审核需求python
  auditRequiresPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AuditRequiresPython`, params);
  },
  // 审核RPA流程退役
  auditRPARetire<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AuditRPARetire`, params);
  },
  // 审核RPA流程添加业务人员
  auditRPAAddMan<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AuditRPAAddMan`, params);
  },
  // 获取需求驳回数量
  getAuditRejectNum<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetAuditRejectNum`, params);
  },
  //导入需求
  importRequires<T>(params: FormData) {
    return services.post(`${base.lk}/Require/ImportRequires`, params);
  },
  //更新需求退役
  updateRequiresRetire<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresRetire`, params);
  },
  //获取Tableau许可申请列表
  getTableauReqList<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetTableauReqList`, params);
  },
  //获取一个需求
  getRequireOneTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresOneTableau`, params);
  },
  //保存需求
  addRequiresTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AddRequiresTableau`, params);
  },
  //更新需求
  updateRequiresTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresTableau`, params);
  },
  //更新需求
  updateRequiresAdminTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresAdminTableau`, params);
  },
  //删除需求
  deleteRequiresTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/DeleteRequiresTableau`, params);
  },
  //提交需求
  submitRequiresTableau<T>(params: FormData) {
    return services.post(`${base.lk}/Require/SubmitRequiresTableau`, params);
  },
  //获取Teambition许可申请列表
  getTeambitionReqList<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetTeambitionReqList`, params);
  },
  //获取一个需求
  getRequireOneTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequireOneTeambition`, params);
  },
  //获取需求操作步骤
  getRequiresStepsTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresStepsTeambition`, params);
  },
  //保存需求
  addRequiresTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AddRequiresTeambition`, params);
  },
  //更新需求
  updateRequiresTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresTeambition`, params);
  },
  //更新需求
  updateRequiresAdminTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresAdminTeambition`, params);
  },
  //删除需求
  deleteRequiresTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/DeleteRequiresTeambition`, params);
  },
  //提交需求
  submitRequiresTeambition<T>(params: FormData) {
    return services.post(`${base.lk}/Require/SubmitRequiresTeambition`, params);
  },
  //判断是否Teambition管理员
  checkIsTeambtionAdmin<T>(params: FormData) {
    return services.post(`${base.lk}/Require/CheckIsTeambtionAdmin`, params);
  },
  //Python 需求模块
  //获取Python需求列表
  getPythonReqList<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetPythonReqList`, params);
  },
  //获取一个需求
  getRequireOnePython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresOnePython`, params);
  },
  //保存需求
  addRequiresPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AddRequiresPython`, params);
  },
  //更新需求
  updateRequiresPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresPython`, params);
  },
  //更新需求管理员
  updateRequiresAdminPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresAdminPython`, params);
  },
  //删除需求
  deleteRequiresPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/DeleteRequiresPython`, params);
  },
  //提交需求
  submitRequiresPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/SubmitRequiresPython`, params);
  },
  //获取python需求操作步骤
  getRequireStepsPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresStepsPython`, params);
  },
  //python需求操作步骤
  getRequireListAdvancePython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresListAdvancePython`, params);
  },
  //导入需求Python
  importRequiresPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/ImportRequiresPython`, params);
  },
  //更新需求退役python
  updateRequiresRetirePython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresRetirePython`, params);
  },
  // 获取需求列表python
  getRequireListPython<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresListPython`, params);
  },
  // 获取需求列表派神易
  getRequireListPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresListPCE`, params);
  },
  //导入派神易需求
  importRequiresPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/ImportRequiresPCE`, params);
  },
  getRequireListAdvancePCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresListAdvancePCE`, params);
  },
  //获取一个需求
  getRequireOnePCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresOnePCE`, params);
  },
  //获取需求操作步骤
  getRequireStepsPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/GetRequiresStepsPCE`, params);
  },
  //保存需求
  addRequiresPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/AddRequiresPCE`, params);
  },
  //更新需求
  updateRequiresPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresPCE`, params);
  },
  //更新需求
  updateRequiresAdminPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresAdminPCE`, params);
  },
  //删除需求
  deleteRequiresPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/DeleteRequiresPCE`, params);
  },
  //提交需求
  submitRequiresPCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/SubmitRequiresPCE`, params);
  },
  //更新需求退役
  updateRequiresRetirePCE<T>(params: FormData) {
    return services.post(`${base.lk}/Require/UpdateRequiresRetirePCE`, params);
  },
};

export default requireManageAPI;
